// Error codes for the roles and permissions module.
export const ROLE_NOT_FOUND = 'ROLE_NOT_FOUND';
export const ROLE_TENANT_MISMATCH = 'ROLE_TENANT_MISMATCH';
export const ROLE_NAME_ALREADY_EXISTS = 'ROLE_NAME_ALREADY_EXISTS';
export const ROLE_SYSTEM_ROLE_READ_ONLY = 'ROLE_SYSTEM_ROLE_READ_ONLY';
export const ROLE_SELF_LOCKOUT = 'ROLE_SELF_LOCKOUT';
export const PERMISSION_NOT_FOUND = 'PERMISSION_NOT_FOUND';
export const MEMBERSHIP_NOT_FOUND = 'MEMBERSHIP_NOT_FOUND';
export const ROLE_ALREADY_ASSIGNED = 'ROLE_ALREADY_ASSIGNED';
export const PERMISSION_DENIED = 'PERMISSION_DENIED';

export const rolesErrorCodes = [
  ROLE_NOT_FOUND,
  ROLE_TENANT_MISMATCH,
  ROLE_NAME_ALREADY_EXISTS,
  ROLE_SYSTEM_ROLE_READ_ONLY,
  ROLE_SELF_LOCKOUT,
  PERMISSION_NOT_FOUND,
  MEMBERSHIP_NOT_FOUND,
  ROLE_ALREADY_ASSIGNED,
  PERMISSION_DENIED,
] as const;

export type RolesErrorCode = (typeof rolesErrorCodes)[number];
